<template>
  <div class="grid grid-cols-12 gap-6">
    <div class="col-span-12 2xl:col-span-9">
      <div class="grid grid-cols-12 gap-6">
        <!-- BEGIN: General Report -->
        <div class="col-span-12 mt-8">
          <TitlePage> {{ $t("homepage") }} </TitlePage>

          <div class="grid grid-cols-12 gap-6 mt-5">
            <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
              <div
                :class="[
                  'relative zoom-in',
                  'before:content-[\'\'] before:w-[90%] before:shadow-[0px_3px_20px_#0000000b] before:bg-slate-50 before:h-full before:mt-3 before:absolute before:rounded-md before:mx-auto before:inset-x-0 before:dark:bg-darkmode-400/70 before:-z-10',
                ]"
              >
                <div class="p-5 box">
                  <div class="flex">
                    <!-- <Lucide
                      icon="ShoppingCart"
                      class="w-[28px] h-[28px] text-primary"
                    /> -->
                    <div class="ml-auto">
                      <!-- <Tippy
                        as="div"
                        class="cursor-pointer bg-success py-[3px] flex rounded-full text-white text-xs pl-2 pr-1 items-center font-medium"
                        content="33% Higher than last month"
                      >
                        33%
                        <Lucide icon="ChevronUp" class="w-4 h-4 ml-0.5" />
                      </Tippy> -->
                    </div>
                  </div>

                  <div class="mt-6 text-3xl font-medium leading-8">4.710</div>

                  <div class="mt-1 text-base text-slate-500">Item Sales</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: General Report -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useHead } from "#app";
  import { computed } from "vue";
  import { useI18n } from "vue-i18n";
  import TitlePage from "~/components/TitlePage/TitlePage.vue";
  import { createHeadTitleWithPrefix } from "~/shared/lib/head";

  const { t } = useI18n();

  useHead({
    title: computed(() => createHeadTitleWithPrefix(t("homepage"))),
  });
</script>
